/* eslint-disable */
import { useAtom } from "jotai";
import globalState from "../../../store";

interface CustomLayoutRadioProps {
  label: string;
  dataField: string;
  setCustomLayout: any;
  v2ImageSource: string;
  v21ImageSource: string;
  v22ImageSource: string;
}

// Utility function to determine if "none" option should be hidden
function shouldHideNoneOption(dataField: string): boolean {
  const fieldsToHideNone = ["modals/text_us"];
  return fieldsToHideNone.includes(dataField);
}

export default function CustomLayoutRadio({
  label,
  dataField,
  setCustomLayout,
  v21ImageSource,
  v2ImageSource,
  v22ImageSource,
}: CustomLayoutRadioProps) {
  const [globalStateAtom, setGlobalState] = useAtom(globalState);

  return (
    <div className="pb-2 w-full border-b-2">
      <h1 className="flex sm:pb-3">{label}</h1>
      <div className="flex-column md:flex w-full justify-between flex-wrap sm:gap-4 gap-2">
        <div className="flex gap-1 items-center">
          <input
            checked={
              globalStateAtom.custom_layout?.[dataField]?.version === "v2"
            }
            type="radio"
            name={dataField}
            value="v2"
            onChange={(e) => {
              setGlobalState({
                ...globalStateAtom,
                custom_layout: {
                  ...globalStateAtom.custom_layout,
                  [dataField]: {
                    ...globalStateAtom.custom_layout[dataField],
                    version: e.target.value,
                  },
                },
              });
              setCustomLayout({
                ...globalStateAtom.custom_layout,
                [dataField]: {
                  ...globalStateAtom.custom_layout[dataField],
                  version: e.target.value,
                },
              });
            }}
          />
          {!v2ImageSource && <div>v2</div>}
          {v2ImageSource && !v2ImageSource.includes("mov") && (
            <img src={v2ImageSource} width="300" alt={label} />
          )}
          {v2ImageSource && v2ImageSource.includes("mov") && (
            <video src={v2ImageSource} width="300" controls />
          )}
        </div>
        <div className="flex gap-1 items-center">
          <input
            checked={
              globalStateAtom.custom_layout?.[dataField]?.version === "v2.1"
            }
            type="radio"
            name={dataField}
            value="v2.1"
            onChange={(e) => {
              setGlobalState({
                ...globalStateAtom,
                custom_layout: {
                  ...globalStateAtom.custom_layout,
                  [dataField]: {
                    ...globalStateAtom.custom_layout[dataField],
                    version: e.target.value,
                  },
                },
              });
              setCustomLayout({
                ...globalStateAtom.custom_layout,
                [dataField]: {
                  ...globalStateAtom.custom_layout[dataField],
                  version: e.target.value,
                },
              });
            }}
          />
          {!v21ImageSource && <div>v2.1</div>}
          {v21ImageSource && !v21ImageSource.includes("mov") && (
            <img src={v21ImageSource} width="300" alt={label} />
          )}
          {v21ImageSource && v21ImageSource.includes("mov") && (
            <video src={v21ImageSource} width="300" controls />
          )}
        </div>
        {dataField === "our-best-work" && (
          <>
            <div className="flex gap-1 items-center">
              <input
                checked={
                  globalStateAtom.custom_layout?.[dataField]?.version === "v2.2"
                }
                type="radio"
                name={dataField}
                value="v2.2"
                onChange={(e) => {
                  setGlobalState({
                    ...globalStateAtom,
                    custom_layout: {
                      ...globalStateAtom.custom_layout,
                      [dataField]: {
                        ...globalStateAtom.custom_layout[dataField],
                        version: e.target.value,
                      },
                    },
                  });
                  setCustomLayout({
                    ...globalStateAtom.custom_layout,
                    [dataField]: {
                      ...globalStateAtom.custom_layout[dataField],
                      version: e.target.value,
                    },
                  });
                }}
              />
              <div className="flex flex-col">
                {v22ImageSource && (
                  <video src={v22ImageSource} width="300" controls />
                )}
                <div>v2.2 with animation</div>
              </div>
            </div>
            <div className="flex gap-1 items-center">
              <input
                checked={
                  globalStateAtom.custom_layout?.[dataField]?.version === "v2.3"
                }
                type="radio"
                name={dataField}
                value="v2.3"
                onChange={(e) => {
                  setGlobalState({
                    ...globalStateAtom,
                    custom_layout: {
                      ...globalStateAtom.custom_layout,
                      [dataField]: {
                        ...globalStateAtom.custom_layout[dataField],
                        version: e.target.value,
                      },
                    },
                  });
                  setCustomLayout({
                    ...globalStateAtom.custom_layout,
                    [dataField]: {
                      ...globalStateAtom.custom_layout[dataField],
                      version: e.target.value,
                    },
                  });
                }}
              />
              <div>v2.3 center aligned with square photos</div>
            </div>
          </>
        )}
        {dataField === "text-us-button" && (
          <div className="flex gap-1 items-center">
            <input
              checked={
                globalStateAtom.custom_layout?.[dataField]?.version === "v2.2"
              }
              type="radio"
              name={dataField}
              value="v2.2"
              onChange={(e) => {
                setGlobalState({
                  ...globalStateAtom,
                  custom_layout: {
                    ...globalStateAtom.custom_layout,
                    [dataField]: {
                      ...globalStateAtom.custom_layout[dataField],
                      version: e.target.value,
                    },
                  },
                });
                setCustomLayout({
                  ...globalStateAtom.custom_layout,
                  [dataField]: {
                    ...globalStateAtom.custom_layout[dataField],
                    version: e.target.value,
                  },
                });
              }}
            />
            <div>v2.2 chat button</div>
          </div>
        )}
        {dataField === "gallery-page" && (
          <div className="flex gap-1 items-center">
            <input
              checked={
                globalStateAtom.custom_layout?.[dataField]?.version === "v2.3"
              }
              type="radio"
              name={dataField}
              value="v2.3"
              onChange={(e) => {
                setGlobalState({
                  ...globalStateAtom,
                  custom_layout: {
                    ...globalStateAtom.custom_layout,
                    [dataField]: {
                      ...globalStateAtom.custom_layout[dataField],
                      version: e.target.value,
                    },
                  },
                });
                setCustomLayout({
                  ...globalStateAtom.custom_layout,
                  [dataField]: {
                    ...globalStateAtom.custom_layout[dataField],
                    version: e.target.value,
                  },
                });
              }}
            />
            <div>v2.3 with square photos</div>
          </div>
        )}
        <div className="flex gap-1 items-center">
          <input
            checked={
              globalStateAtom.custom_layout?.[dataField]?.version === "v3"
            }
            type="radio"
            name={dataField}
            value="v3"
            onChange={(e) => {
              setGlobalState({
                ...globalStateAtom,
                custom_layout: {
                  ...globalStateAtom.custom_layout,
                  [dataField]: {
                    ...globalStateAtom.custom_layout[dataField],
                    version: e.target.value,
                  },
                },
              });
              setCustomLayout({
                ...globalStateAtom.custom_layout,
                [dataField]: {
                  ...globalStateAtom.custom_layout[dataField],
                  version: e.target.value,
                },
              });
            }}
          />
          <span>v3</span>
        </div>
        <div className="flex gap-1 items-center">
          <input
            checked={
              globalStateAtom.custom_layout?.[dataField]?.version === "v4"
            }
            type="radio"
            name={dataField}
            value="v4"
            onChange={(e) => {
              setGlobalState({
                ...globalStateAtom,
                custom_layout: {
                  ...globalStateAtom.custom_layout,
                  [dataField]: {
                    ...globalStateAtom.custom_layout[dataField],
                    version: e.target.value,
                  },
                },
              });
              setCustomLayout({
                ...globalStateAtom.custom_layout,
                [dataField]: {
                  ...globalStateAtom.custom_layout[dataField],
                  version: e.target.value,
                },
              });
            }}
          />
          <span>v4</span>
        </div>

        {/* v5 components don't exist for the following sections */}
        {![
          "reviews-page",
          "team-page",
          "jobs-page",
          "custom-page",
          "gallery-page",
          "modals/leave_a_review",
          "modals/text_thank_you",
          "modals/text_us",
        ].includes(dataField) && (
          <div className="flex gap-1 items-center">
            <input
              checked={
                globalStateAtom.custom_layout?.[dataField]?.version === "v5"
              }
              type="radio"
              name={dataField}
              value="v5"
              onChange={(e) => {
                setGlobalState({
                  ...globalStateAtom,
                  custom_layout: {
                    ...globalStateAtom.custom_layout,
                    [dataField]: {
                      ...globalStateAtom.custom_layout[dataField],
                      version: e.target.value,
                    },
                  },
                });
                setCustomLayout({
                  ...globalStateAtom.custom_layout,
                  [dataField]: {
                    ...globalStateAtom.custom_layout[dataField],
                    version: e.target.value,
                  },
                });
              }}
            />
            <span>v5</span>
          </div>
        )}
        {!shouldHideNoneOption(dataField) && (
          <div className="flex gap-1 items-center">
            <input
              checked={
                globalStateAtom.custom_layout?.[dataField]?.version === "none"
              }
              type="radio"
              name={dataField}
              value="none"
              disabled={dataField === "modals/text_thank_you"}
              onChange={(e) => {
                setGlobalState({
                  ...globalStateAtom,
                  custom_layout: {
                    ...globalStateAtom.custom_layout,
                    [dataField]: {
                      ...globalStateAtom.custom_layout[dataField],
                      version: e.target.value,
                    },
                  },
                });
                setCustomLayout({
                  ...globalStateAtom.custom_layout,
                  [dataField]: {
                    ...globalStateAtom.custom_layout[dataField],
                    version: e.target.value,
                  },
                });
              }}
            />
            <div>none</div>
          </div>
        )}
      </div>
    </div>
  );
}
